import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { posthog } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { AuthErrorDialog } from "@/components/custom/auth-error-dialog";
import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "./lib/query-client";
import { router } from "./router";

export const Providers = () => {
  return (
    <PostHogProvider client={posthog}>
      <QueryClientProvider client={queryClient}>
        <Toaster position="top-center" richColors />
        <RouterProvider router={router} />
        <AuthErrorDialog />
        {/* Devtools */}
        {/* <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
          <Suspense>
            <RouterDevtools router={router} position="bottom-right" />
          </Suspense> */}
      </QueryClientProvider>
    </PostHogProvider>
  );
};

export default Providers;
